"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var toggle_1 = __importDefault(require("relements/build/esm/input/toggle"));
var InfoIconV4_1 = __importDefault(require("relements/build/esm/ui/icons/InfoIconV4"));
// Constants
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var const_1 = require("@src/const");
var _utils_1 = require("@src/components/BotResponses/BotSays/_utils");
// helpers
var hslBuilder_1 = __importDefault(require("@haptik/helpers/build/esm/hslBuilder"));
var hslDisplay_1 = __importDefault(require("@haptik/helpers/build/esm/hslDisplay"));
// Store
var store_1 = __importDefault(require("@src/store"));
// Components
var RHSLoader_1 = __importDefault(require("@src/components/BotResponses/RHSLoader"));
var Slider_1 = __importDefault(require("@src/components/Slider"));
// Styled-Components
var StyledComponets_1 = require("./StyledComponets");
var MultiLineError_1 = __importDefault(require("./MultiLineError"));
var FollowUpMessage = function (_a) {
    var handleFollowUpMessage = _a.handleFollowUpMessage, value = _a.value, onChange = _a.onChange, _b = _a.currentChannelName, currentChannelName = _b === void 0 ? 'WebSDK' : _b, isTranslateLoading = _a.isTranslateLoading, followupEnabled = _a.followupEnabled, handleToggle = _a.handleToggle, followupDelay = _a.followupDelay, _c = _a.disabled, disabled = _c === void 0 ? false : _c, errors = _a.errors;
    var followUpMessage = value && value.length ? value.map(function (variant) { return variant.join('<m>'); }) : [];
    var renderHSL = function () {
        var hslProps = {
            value: followUpMessage,
            withVariants: true,
            withReplies: true,
            onChange: function (value) { return onChange(value); },
            currentChannelName: currentChannelName,
        };
        if (!disabled) {
            return (react_1["default"].createElement(hslBuilder_1["default"], __assign({ isRephraseEnabled: store_1["default"].getFeatureFlag(MogamboConstants_1.FEATURE_FLAG_DATA.FLAGS.ENABLE_REPHRASE_RESPONSES), baseUrl: const_1.BASE_URL }, hslProps)));
        }
        return react_1["default"].createElement(hslDisplay_1["default"], __assign({}, hslProps));
    };
    var renderFollowUpMessageHeader = function () {
        return (react_1["default"].createElement(box_1["default"], { padding: "0", paddingLeft: "16px", justifyContent: "space-between", alignItems: "center" },
            react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold", color: "black.haptik" }, "Follow Up Message"),
            react_1["default"].createElement(toggle_1["default"], { value: followupEnabled, onChange: handleToggle, disabled: disabled })));
    };
    var renderSliderContainer = function () {
        return (react_1["default"].createElement(box_1["default"], { marginLeft: "24px", padding: "0", flexDirection: "column" },
            react_1["default"].createElement(Slider_1["default"], { min: 1, max: 1200, step: 1, leftLabel: "1s", rightLabel: "20min", labelMarginTop: "-7px", value: followupDelay, onChange: handleFollowUpMessage, disabled: disabled, isAiAgent: true })));
    };
    var renderHslVariantsContainer = function () {
        var _a, _b;
        return (react_1["default"].createElement(box_1["default"], { padding: "0", style: {
                flexDirection: 'column',
                marginTop: '12px',
                marginLeft: '16px',
                zIndex: '0',
            } },
            react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, "Variants"),
            react_1["default"].createElement(StyledComponets_1.HSLWrapper, { error: (_a = errors === null || errors === void 0 ? void 0 : errors.actionErrors) === null || _a === void 0 ? void 0 : _a.followUpHslError }, !isTranslateLoading ? (renderHSL()) : (react_1["default"].createElement(RHSLoader_1["default"], { relativeAlign: true, text: "Loading " + currentChannelName + " translations" }))),
            react_1["default"].createElement(MultiLineError_1["default"], { error: (_b = errors === null || errors === void 0 ? void 0 : errors.actionErrors) === null || _b === void 0 ? void 0 : _b.followUpHslError })));
    };
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", backgroundColor: "grey.pastel", margin: "0 16px 16px 0" },
            renderFollowUpMessageHeader(),
            react_1["default"].createElement(StyledComponets_1.StyledText, { variant: "body.md", color: "grey.deep", marginTop: "0", marginBottom: followupEnabled ? '34px' : '0', marginLeft: "16px" },
                "Send follow up messages to user after",
                ' ',
                followupEnabled
                    ? _utils_1.getHumanReadableDurationFull(followupDelay) || '0 second'
                    : 'few seconds',
                "."),
            followupEnabled && (react_1["default"].createElement(react_1["default"].Fragment, null,
                renderSliderContainer(),
                renderHslVariantsContainer())),
            disabled && (react_1["default"].createElement(box_1["default"], { padding: "12px 8px", margin: "8px 0 0 16px", backgroundColor: "blue.pastel", borderRadius: "6px", borderColor: "blue.haptik", borderStyle: "solid", borderWidth: "1px", style: { gap: '8px' } },
                react_1["default"].createElement(InfoIconV4_1["default"], { size: "big", iconColor: "blue.dark", marginLeft: "4px", minWidth: "28px" }),
                react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "blue.dark" }, "Follow-up message is unavailable when feedback is enabled."))))));
};
exports["default"] = FollowUpMessage;
